// ./src/components/generic/DateTimeFormatSelector/DateTimeFormatSelector.tsx
import React from "react";
import { Select, SelectProps } from "@mantine/core";

const DATETIME_FORMAT_OPTIONS = [
  {
    value: "h:mm A",
    label: "Time (12h)",
    description: "3:45 PM",
    category: "Time Only",
  },
  {
    value: "HH:mm",
    label: "Time (24h)",
    description: "15:45",
    category: "Time Only",
  },
  {
    value: "MMMM D, YYYY",
    label: "Date (Long)",
    description: "January 15, 2024",
    category: "Date Only",
  },
  {
    value: "MMM D, YYYY",
    label: "Date (Short)",
    description: "Jan 15, 2024",
    category: "Date Only",
  },
  {
    value: "D MMMM YYYY",
    label: "Date (Day First)",
    description: "15 January 2024",
    category: "Date Only",
  },
  {
    value: "MM/DD/YYYY",
    label: "Date (Numeric)",
    description: "01/15/2024",
    category: "Date Only",
  },
  {
    value: "MMMM D, YYYY h:mm A",
    label: "Date & Time (12h)",
    description: "January 15, 2024 3:45 PM",
    category: "Date & Time",
  },
  {
    value: "MMMM D, YYYY HH:mm",
    label: "Date & Time (24h)",
    description: "January 15, 2024 15:45",
    category: "Date & Time",
  },
] as const;

export interface DateTimeFormatSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current date/time format value (dayjs format string) */
  value: string | null | undefined;

  /** Callback when format changes */
  onChange: (value: string | null) => void;

  /** Whether to show descriptions in the dropdown */
  withDescriptions?: boolean;
}

export const DateTimeFormatSelector: React.FC<DateTimeFormatSelectorProps> = ({
  value,
  onChange,
  withDescriptions = false,
  placeholder = "Select date/time format",
  label,
  description,
  error,
  ...selectProps
}) => {
  // Prepare select data with optional descriptions
  const selectData = DATETIME_FORMAT_OPTIONS.map((option) => {
    let label: string = option.label;

    if (withDescriptions) {
      label = `${option.label} - ${option.description}`;
    }

    return {
      value: option.value,
      label,
      //group: option.category,
    };
  });

  return (
    <Select
      {...selectProps}
      label={label}
      description={description}
      error={error}
      data={selectData}
      value={value || null}
      onChange={onChange}
      placeholder={placeholder}
      clearable={false}
    />
  );
};

// Export format options for use in other components
export { DATETIME_FORMAT_OPTIONS };
